// extracted by mini-css-extract-plugin
export var backContainer = "listGdd-module--back-container--c5f58";
export var backLink = "listGdd-module--back-link--6dacc";
export var backToSite = "listGdd-module--back-to-site--5cbda";
export var imgLogo = "listGdd-module--img-logo--80e00";
export var listGdd = "listGdd-module--list-gdd--e607a";
export var titleGdd = "listGdd-module--title-gdd--7c401";